import React, { useEffect } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'

import classes from './style.module.css'
import Loader from '../../../../../images/icon/loader.svg'
import store from '../../../../../redux'
import { amountAction, swapCurrencyButtonAction } from '../../../../../redux/stores/firstScreen/action'
import { strings } from '../../../../../i18n'
import getEquivalentData from '../elements/function/getEquivalentData'
import config from '../../../../../config/environment'

const { dispatch } = store
const reCaptchaRef = React.createRef()

export const amountInputHandler = async (state, event, onLoad = false) => {
    if (state.amountTimerId) { clearTimeout(state.amountTimerId) }

    let value
    try {
        value = event.target.value
    } catch {
        value = event
    }

    const amount = parseFloat(value) || value

    if (amount < state.minMaxLimits.min || amount > state.minMaxLimits.max) {
        dispatch(amountAction(amount, null, true))
        return
    }

    const timerId = setTimeout(async () => {
        typeof reCaptchaRef.current !== 'undefined' && reCaptchaRef && reCaptchaRef.current.reset()
        const captchaToken = await reCaptchaRef.current.executeAsync()

        const equivalentData = await getEquivalentData(state, amount, captchaToken)

        reCaptchaRef.current.reset()

        if (!equivalentData) {
            dispatch(amountAction(amount, null, true))
            return
        }

        dispatch(amountAction(amount, null, false, equivalentData))
    }, 1e3) // 1 sec

    dispatch(amountAction(amount, timerId))

}

const SwapCurrencyButton = (props) => {

    const { state } = props

    if (!state.swapCurrencyButtonName) {
        return null
    }

    return (
        <input
            type='submit'
            onClick={() => swapCurrencyButtonHandler(state)}
            value={state.swapCurrencyButtonName.length > 5 ? state.swapCurrencyButtonName.slice(4, state.swapCurrencyButtonName.length) : state.swapCurrencyButtonName}
        />
    )
}

const swapCurrencyButtonHandler = (state) => {
    let swapCurrencyButtonName = state.swapCurrencyButtonName === state.inCurrency ? state.outCurrency : state.inCurrency
    dispatch(swapCurrencyButtonAction(state, swapCurrencyButtonName))
}

const Limits = (props) => {

    const { state } = props

    if (!state.minMaxLimits) {
        return null
    }

    const currencyCode = state.minMaxLimits.currencySide === 'IN' ? state.inCurrency : state.outCurrency

    return (
        <div className={classes.amounts__limits_wrapper}>
            <div
                className={state.amountValid ? classes.max__min__limits : null}
                onClick={() => {
                    if (!state.editAmount) return null
                    amountInputHandler(state, state.minMaxLimits.min)
                    dispatch(swapCurrencyButtonAction(state, currencyCode))
                }}
            >Min: {state.minMaxLimits.min + ' ' + currencyCode}</div>
            <div className={state.amountValid ? classes.max__min__limits : null} style={{ paddingTop: 7 }}
                onClick={() => {
                    if (!state.editAmount) return null
                    amountInputHandler(state, state.minMaxLimits.max)
                    dispatch(swapCurrencyButtonAction(state, currencyCode))
                }}
            >Max: {state.minMaxLimits.max + ' ' + currencyCode}</div>
        </div>
    )
}

const MobileLimits = (props) => {
    const { state } = props

    if (!state.minMaxLimits) {
        return null
    }

    const currencyCode = state.minMaxLimits.currencySide === 'IN' ? state.inCurrency : state.outCurrency

    return (
        <div className={classes.mobile__amounts__limits_wrapper}>
            <div
                className={classes.mobile__max__min__limits}
                onClick={() => {
                    amountInputHandler(state, state.minMaxLimits.min)
                    dispatch(swapCurrencyButtonAction(state, currencyCode))
                }}
            >Min: {state.minMaxLimits.min + ' ' + currencyCode}</div>
            <div className={classes.mobile__max__min__limits}
                onClick={() => {
                    amountInputHandler(state, state.minMaxLimits.max)
                    dispatch(swapCurrencyButtonAction(state, currencyCode))
                }}
            >Max: {state.minMaxLimits.max + ' ' + currencyCode}</div>
        </div>
    )
    

}

const renderEquivalent = (state) => {
    if (!state.equivalentData) {
        return
    }

    const equivalentAmount = state.swapCurrencyButtonName === state.inCurrency ? state.equivalentData.equivalentData.outAmount : state.equivalentData.equivalentData.inAmount
    const equivalentCurrencyCode = state.swapCurrencyButtonName === state.inCurrency ? state.outCurrency : state.inCurrency

    return (
        <div className={classes.equivalent_value_wrapper}>
            {strings('firstScreen.equivalent')}:
            <div className={classes.equivalent_value}>
                {equivalentAmount} {equivalentCurrencyCode.length > 5 ? equivalentCurrencyCode.slice(4, equivalentCurrencyCode.length) : equivalentCurrencyCode}
            </div>
        </div>
    )
}

// Amounts
const Amounts = (props) => {

    const { state } = props

    useEffect(() => {
        amountInputHandler(state, state.amount)

        return () => {

        }
    }, [])

    return (
        <>
            <div className={classes.amount__wrapper}>
                <div className={classes.amount}>
                    <input
                        type='number'
                        placeholder={strings('firstScreen.amount')}
                        onChange={event => amountInputHandler(state, event)}
                        value={state.amount || ' '}
                        readOnly={!state.editAmount}
                    />
                    <SwapCurrencyButton state={state} />
                </div>
                <Limits state={state} />
            </div>
            <div className={classes.equivalent}>
                {!state.externalId ?
                    state.amount && state.amountTimerId ?
                        <img src={Loader} height={30} alt='preloader' /> :
                        state.amount <= state.minMaxLimits.max && state.amount >= state.minMaxLimits.min ?
                            renderEquivalent(state) : null : null}

            </div>
            {!state.externalId && <MobileLimits state={state} />}
            <ReCAPTCHA
                ref={reCaptchaRef}
                size="invisible"
                sitekey={config.captchaSiteKey}
                style={{ position: 'absolute', top: '20%' }}
            />
        </>
    )
}

export default Amounts